import axios from "axios";
import { useAuthStore } from "@/store/auth";
import {ElMessage} from "element-plus";

export const baseURL = "https://ga.jxjkx.com"
const api = axios.create({
    baseURL: baseURL, // 设置API的基本URL

    // baseURL: "http://10.11.9.132:8002", // 设置API的基本URL
    // baseURL: "http://192.168.83.3:8081/api", // 设置API的基本URL
    timeout: 30000, // 设置请求超时时间
    headers: {
        "Content-Type": "application/json",
    }
})

api.interceptors.request.use(
    (config) => {
        // 在请求发送之前做一些处理
        const token = useAuthStore().token
        // console.log("token: " + token)
        if (token) {
            config.headers.TOKEN = token;
        }
        return config;
    },
    (error) => {
        // 处理请求错误
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        if (response.config.responseType === 'blob') {
            return response;
        }
        // 在响应数据之前做一些处理
        const data = response.data
        if (data.status !== 0 && data.status !== '0') {
            if (data.status === '401') {
                console.log("401")
                location.href = "/login"
            }
            // 处理错误
            ElMessage({
                message: data.msg,
                type: 'error'
            })
            return Promise.reject(new Error('Error'))
        } else {
            // 处理正常响应
            return data;
        }

    },
    (error) => {
        // 处理响应错误
        console.log('err' + error) // for debug
        ElMessage({
            message: error.message,
            type: 'error'
        })
        return Promise.reject(error);
    }
);

export const exportExcel = (url, params, filename = 'export.xlsx') => {
    return api.get(url, {
        params,
        responseType: 'blob'
    }).then(response => {
        // 自动处理下载逻辑
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;

        // 获取文件名
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch[1]) {
                filename = fileNameMatch[1];
            }
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        return response;
    });
};

export default api